import React, { useEffect, useState } from "react";
import {
  Box,
  Autocomplete,
  FormGroup,
  FormControlLabel,
  Switch,
  Checkbox,
  TextField,
  CircularProgress,
} from "@mui/material";
import CustomButton from "shared/custom-button/CustomButton";
import { colors } from "app/providers/theme/colors-type";
import styles from "features/health-ai/step-2/ui/Insured.module.css";
import { NestedKeyOf } from "shared/utils/hooks/useFormRedux";
import { useAppDispatch, useAppSelector } from "shared/utils/hooks/useRedux";
import InfoIcon from "@mui/icons-material/Info";
import { IStepTwo } from "entities/health-ai/step-2/types/StepTwo-inerface";
import { CountriesData } from "entities/health-ai/step-2/selsctor";
import { RoundedAutocomplete } from "shared/basic-autocomplete/RoundedAutocomplete";

const genderOptions = [
  { label: "Мужской", value: "Мужской" },
  { label: "Женский", value: "Женский" },
];

interface InsuredProps {
  formState: IStepTwo;
  errors: Record<string, string>;
  handleBack: () => void;
  handleChange: (
    fieldName: NestedKeyOf<IStepTwo> | keyof IStepTwo
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (
    fieldName: NestedKeyOf<IStepTwo> | keyof IStepTwo
  ) => (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleCheckboxChange: (
    fieldName: NestedKeyOf<IStepTwo> | keyof IStepTwo
  ) => (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  handleArrayDateChange: (
    fieldName: string
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleNext: () => void;
  formatPhone: (phone: string) => string;
  handleArrayPhoneChange: (
    fieldName: NestedKeyOf<IStepTwo> | keyof IStepTwo
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDocumentSeriesChange: (
    fieldName: NestedKeyOf<IStepTwo> | keyof IStepTwo
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDocumentNumberChange: (
    fieldName: NestedKeyOf<IStepTwo> | keyof IStepTwo
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAutocompleteChange: (
    fieldName: NestedKeyOf<IStepTwo> | keyof IStepTwo
  ) => (value: string) => void;
  handleDateChange: (
    fieldName: NestedKeyOf<IStepTwo> | keyof IStepTwo
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Insured: React.FC<InsuredProps> = ({
  formState,
  errors,
  handleBack,
  handleChange,
  handleBlur,
  handleCheckboxChange,
  handleArrayDateChange,
  handleNext,
  formatPhone,
  handleArrayPhoneChange,
  handleAutocompleteChange,
  handleDocumentNumberChange,
  handleDocumentSeriesChange,
  handleDateChange,
}) => {
  const dispatch = useAppDispatch();

  const handlePolicyholderIsSameChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    handleCheckboxChange("PolicyholderIsSame")(e, checked);
  };

  const { Countries, isLoadingCountries } = useAppSelector(CountriesData);

  const selectedCountry =
    Countries?.find(
      (country) => country.ID === formState.Insureds[0].CountryID
    ) || null;

  //   useEffect(() => {
  //     if (!formState.Insureds[0].CountryID) {
  //       handleAutocompleteChange("Insureds[0].CountryID")(
  //         "7434be15-0c71-11eb-80d7-00155d65b075"
  //       );
  //     }
  //   }, []);

  const isRussia =
    Countries?.find((country) => country.ID === formState.Insureds[0].CountryID)
      ?.Name === "РОССИЯ";
  return (
    <Box>
      <Box className={styles.formBox}>
        <Box className={styles.titleBox}>
          <h4>Застрахованный</h4>
          <Box className={styles.fullWidthBox}>
            <FormControlLabel
              control={
                <Checkbox
                  name="PolicyholderIsSame"
                  checked={Boolean(formState.PolicyholderIsSame)}
                  onChange={handlePolicyholderIsSameChange}
                  sx={{
                    color: "grey.500",
                    "&.Mui-checked": {
                      color: colors.primary,
                    },
                  }}
                />
              }
              label="Буду являться застрахованным"
            />
          </Box>
        </Box>
        {!formState.PolicyholderIsSame && (
          <Box className={styles.formFields}>
            <Box className={styles.twoLine}>
              <TextField
                name={`Insureds[0].LastName`}
                label="Фамилия"
                value={formState.Insureds[0].LastName}
                onChange={handleChange("Insureds[0].LastName")}
                onBlur={(e) => {
                  handleBlur(`Insureds[0].LastName`)(e);
                }}
                error={!!errors[`Insureds[0].LastName`]}
                helperText={errors[`Insureds[0].LastName`]}
              />
              <TextField
                name={`Insureds[0].FirstName`}
                label="Имя"
                value={formState.Insureds[0].FirstName}
                onChange={handleChange("Insureds[0].FirstName")}
                onBlur={(e) => {
                  handleBlur(`Insureds[0].FirstName`)(e);
                }}
                error={!!errors[`Insureds[0].FirstName`]}
                helperText={errors[`Insureds[0].FirstName`]}
              />
            </Box>
            <Box className={styles.twoLine}>
              <TextField
                name={`Insureds[0].MiddleName`}
                label="Отчество"
                value={formState.Insureds[0].MiddleName}
                onChange={handleChange("Insureds[0].MiddleName")}
                onBlur={(e) => {
                  handleBlur("Insureds[0].MiddleName")(e);
                }}
                error={!!errors["Insureds[0].MiddleName"]}
                helperText={errors["Insureds[0].MiddleName"]}
              />
              <TextField
                name={`Insureds[0].BirthDate`}
                label="Дата рождения"
                value={formState.Insureds[0].BirthDate}
                placeholder="дд.мм.гггг"
                onChange={handleArrayDateChange("Insureds[0].BirthDate")}
                onBlur={(e) => {
                  handleBlur("Insureds[0].BirthDate")(e);
                }}
                error={!!errors["Insureds[0].BirthDate"]}
                helperText={errors["Insureds[0].BirthDate"]}
              />
            </Box>
            <Box className={styles.twoLine}>
              <RoundedAutocomplete
                name="Insureds[0].Gender"
                label="Пол"
                value={formState.Insureds[0].Gender}
                onChange={(value) => {
                  handleAutocompleteChange("Insureds[0].Gender")(value);
                }}
                onBlur={() => {
                  handleBlur("Insureds[0].Gender")({
                    target: { value: formState.Insureds[0].Gender },
                    currentTarget: {
                      value: formState.Insureds[0].Gender,
                    } as HTMLInputElement,
                  } as React.FocusEvent<HTMLInputElement>);
                }}
                options={genderOptions}
                error={!!errors["Insureds[0].Gender"]}
                helperText={errors["Insureds[0].Gender"]}
              />
              <TextField
                name={`Insureds[0].Phone`}
                label="Телефон"
                value={formatPhone(formState.Insureds[0].Phone)}
                onChange={handleArrayPhoneChange("Insureds[0].Phone")}
                onBlur={(e) => {
                  handleBlur("Insureds[0].Phone")(e);
                }}
                error={!!errors["Insureds[0].Phone"]}
                helperText={errors["Insureds[0].Phone"]}
              />
            </Box>

            <Box className={styles.formFields}>
              <Autocomplete
                options={Countries || []}
                getOptionLabel={(option) => option.Name}
                isOptionEqualToValue={(option, value) => option.ID === value.ID}
                value={selectedCountry}
                onChange={(_event, newValue) => {
                  handleAutocompleteChange("Insureds[0].CountryID")(
                    newValue ? newValue.ID : ""
                  );
                }}
                onBlur={() => {
                  handleBlur("Insureds[0].CountryID")({
                    target: { value: formState.Insureds[0].CountryID },
                    currentTarget: {
                      value: formState.Insureds[0].CountryID,
                    } as HTMLInputElement,
                  } as React.FocusEvent<HTMLInputElement>);
                }}
                loading={isLoadingCountries}
                loadingText="Загрузка..."
                noOptionsText="Страна не найдена"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Страна"
                    error={!!errors["Insureds[0].CountryID"]}
                    helperText={errors["Insureds[0].CountryID"]}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {isLoadingCountries ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                filterOptions={(options, state) => {
                  const inputValue = state.inputValue.trim().toLowerCase();
                  if (inputValue === "") {
                    return options;
                  }
                  return options.filter((option) =>
                    option.Name.toLowerCase().includes(inputValue)
                  );
                }}
                popupIcon={null}
                fullWidth
              />
            </Box>
            {formState.Insureds[0].CountryID && !isRussia && (
              <>
                <Box className={styles.titleOterBox}>
                  <h4>Паспортные данные</h4>
                </Box>

                <Box className={styles.formFields}>
                  <Box className={styles.twoLine}>
                    <TextField
                      name="Insureds[0].DocumentSeries"
                      label="Серия"
                      value={formState.Insureds[0].DocumentSeries}
                      onChange={handleChange("Insureds[0].DocumentSeries")}
                      onBlur={(e) => {
                        handleBlur("Insureds[0].DocumentSeries")(e);
                      }}
                      error={!!errors["Insureds[0].DocumentSeries"]}
                      helperText={errors["Insureds[0].DocumentSeries"]}
                    />
                    <TextField
                      name="Insureds[0].DocumentNumber"
                      label="Номер"
                      value={formState.Insureds[0].DocumentNumber}
                      onChange={handleChange("Insureds[0].DocumentNumber")}
                      onBlur={(e) => {
                        handleBlur("Insureds[0].DocumentNumber")(e);
                      }}
                      error={!!errors["Insureds[0].DocumentNumber"]}
                      helperText={errors["Insureds[0].DocumentNumber"]}
                    />
                  </Box>
                  <Box className={styles.twoLine}>
                    <TextField
                      name="Insureds[0].DocumentDate"
                      label="Дата выдачи"
                      value={formState.Insureds[0].DocumentDate}
                      placeholder="дд.мм.гггг"
                      onChange={handleArrayDateChange(
                        "Insureds[0].DocumentDate"
                      )}
                      onBlur={(e) => {
                        handleBlur("Insureds[0].DocumentDate")(e);
                      }}
                      error={!!errors["Insureds[0].DocumentDate"]}
                      helperText={errors["Insureds[0].DocumentDate"]}
                    />
                  </Box>
                </Box>
              </>
            )}
          </Box>
        )}
      </Box>

      <Box className={styles.btnBoxNext}>
        <CustomButton
          title="Назад"
          handleClick={handleBack}
          textColor={colors.primary}
          backgroundColor="none"
          width="150px"
          gap="10px"
          borderRadius="4px"
          padding="3px"
          border="none"
        />
        <CustomButton
          title="Далее"
          handleClick={handleNext}
          textColor="white"
          backgroundColor={colors.primary}
          width="150px"
          gap="10px"
          borderRadius="4px"
          padding="3px"
        />
      </Box>
    </Box>
  );
};
